export const SELLER_TYPE = 'seller'
export const BUYER_TYPE = 'buyer'
type CompanyType = 'seller' | 'buyer' | null

export interface OfferState {
  data: any
  companyType: CompanyType
}
